<script>
  import Icon from 'fa-svelte'
  import { faTerminal } from '@fortawesome/free-solid-svg-icons/faTerminal'
</script>

<div class="icon"><Icon icon={faTerminal} /></div>

<style>
  .icon {
    font-size: 2em;
    color: #009edf;
  }

  @media screen and (max-width: 800px) {
  .icon {
    font-size: 1.5em;

  }
}
</style>

<!-- markup (zero or more items) goes here -->